import { getPlannerProductEntities } from '../../platform/utils/scene-entity-utils';
import { findSelectedEntity } from '../../platform/utils/selection-utils';
import { getGlobalArticleNumber } from '../../platform/utils/product-info-entity-utils';
import { getWorldPosition, getWorldRotation } from '../../platform/utils/entity-transform-utils';
import { getEntityFrame, isEntityFrame } from './getEntityFrame';
/**
 * Returns scene articles.
 *
 * @param core Core Instance.
 * @returns Scene articles.
 */
export function getAnalyticsSceneArticles({ core }) {
    let articlesInScene = [];
    // coreApi might be a NoCore reference from useCoreApi
    try {
        const allPlannerProductEntities = getPlannerProductEntities(core);
        const selectedEntity = findSelectedEntity(core);
        articlesInScene = allPlannerProductEntities.map(entity => {
            const frameId = getEntityFrame(entity)?.id;
            return {
                articleNumber: getGlobalArticleNumber(entity) ?? undefined,
                frameId,
                id: entity.id,
                isFrame: isEntityFrame(entity),
                isFrameSelected: !!selectedEntity && selectedEntity?.id === frameId,
                rotation: getWorldRotation(entity).toEulerDegrees(),
                position: getWorldPosition(entity),
                isSelected: selectedEntity?.id === entity.id
            };
        });
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
    // Verbose property name to not overwrite properties
    return articlesInScene;
}
//# sourceMappingURL=analyticsSceneArticles.js.map